import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface MinSaleBoxProps {
  minSaleQty: number
}
const MinSaleBox: FC<MinSaleBoxProps> = ({ minSaleQty }) => {
  const { t: translate } = useTranslation('common')
  return minSaleQty > 1 ? (
    <div className="border-gray-300 border p-4 rounded font-sofia my-2">
      <h1 className="text-red-700  font-bold text-center">
        {translate('text-min-order')}
      </h1>
      <p className="text-brand-black text-sm mt-2 text-center">{`${translate(
        'text-min-order-description',
      )}  ${minSaleQty}`}</p>
    </div>
  ) : null
}

export default MinSaleBox
